import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
 
const NotFoundPage = () => {
  const navigate = useNavigate();
 
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        textAlign: "center",
        gap: 2,
      }}
    >
      <Typography variant="h1" sx={{ fontSize: "100px", fontWeight: "bold", color: "#fff" }}>
        404
      </Typography>
      <Typography variant="h5" sx={{ color: "#d9d9d9", mb: 2 }}>
        Page Not Found
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate("/")}
        sx={{
          backgroundColor: "#28ABE2",
          padding: "10px 30px",
          borderRadius: "25px",
          "&:hover": { backgroundColor: "#2196f3" },
        }}
      >
        Go to Home
      </Button>
    </Box>
  );
};
 
export default NotFoundPage;
